// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._ThgWY{position:absolute;left:0;right:0;top:0;z-index:67}.ZgAE06{height:100%}.f5Dhhm,.ZgAE06{max-width:none;max-height:none;position:static !important;transition:0.2s, opacity 0.2s;transition-timing-function:initial}.i9rx6l{position:absolute;top:0;z-index:100;margin-top:15px;display:flex;align-items:flex-end;flex-direction:column;flex:1;transition:opacity .2s, visibility .2s}.i9rx6l.hGhdN0{direction:ltr;right:0;margin-right:18px;margin-left:36px}.i9rx6l.PNvvI1{direction:rtl;left:0;margin-right:36px;margin-left:18px}.rF0_du{position:relative}.iGAbJA{height:11px;width:11px;background-color:#ea492e;border-radius:50%;position:absolute;top:6px;right:6px}.t40cvk{display:none}.Xt5iUl{display:block}.P363hT{padding:0;margin-bottom:18px}.M3c7qG .ZOXb4j{max-width:0;overflow:hidden}.M3c7qG .ZOXb4j:after{opacity:0;transition:opacity 0.3s 0.2s ease}.M3c7qG:hover .ZOXb4j{transition:max-width 0.4s;max-width:200px;overflow:visible}.M3c7qG:hover .ZOXb4j:after{opacity:1}.TSxjmb.BSyWNf.hGhdN0,.M3c7qG:hover.hGhdN0{padding-left:18px}.TSxjmb.BSyWNf.PNvvI1,.M3c7qG:hover.PNvvI1{padding-right:18px}div[data-vod-player-max-width~="1900px"] .P363hT{margin-bottom:12px}div[data-vod-player-max-width~="1900px"] .iGAbJA{height:8px;width:8px;top:4px;right:4.5px}div[data-vod-player-max-width~="1900px"] .TSxjmb.BSyWNf.hGhdN0,div[data-vod-player-max-width~="1900px"] .M3c7qG:hover.hGhdN0{padding-left:12px}div[data-vod-player-max-width~="1900px"] .TSxjmb.BSyWNf.PNvvI1,div[data-vod-player-max-width~="1900px"] .M3c7qG:hover.PNvvI1{padding-right:12px}div[data-vod-player-max-width~="550px"] .t40cvk{display:block}div[data-vod-player-max-width~="550px"] .Xt5iUl{display:none}div[data-vod-player-max-width~="550px"] .i9rx6l{margin-top:12px;margin-right:12px}div[data-vod-player-max-width~="550px"] .P363hT{margin-bottom:6px}div[data-vod-player-max-width~="550px"] .iGAbJA{height:6px;width:6px;top:4px;right:4px}div[data-vod-player-max-width~="350px"] .Vd_crt,div[data-vod-player-max-width~="350px"] ._PBp_b,div[data-vod-player-max-width~="350px"] .rF0_du{display:none}div[data-vod-player-max-width~="280px"] .P363hT{display:none}.B_wG0T{position:absolute;top:0;left:0;right:0;bottom:0;z-index:8}.B_wG0T.FhMWcS{z-index:70}.TEk3Sb{position:absolute;top:0;left:0;right:0;bottom:0}.aRfedH{background-color:rgba(0,0,0,0.35)}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main-content-wrapper": `_ThgWY`,
	"mainContentWrapper": `_ThgWY`,
	"info-overlay": `ZgAE06`,
	"infoOverlay": `ZgAE06`,
	"main-content": `f5Dhhm`,
	"mainContent": `f5Dhhm`,
	"actions": `i9rx6l`,
	"ltr": `hGhdN0`,
	"rtl": `PNvvI1`,
	"chat-button": `rF0_du`,
	"chatButton": `rF0_du`,
	"chat-pimple": `iGAbJA`,
	"chatPimple": `iGAbJA`,
	"chat-small": `t40cvk`,
	"chatSmall": `t40cvk`,
	"chat-big": `Xt5iUl`,
	"chatBig": `Xt5iUl`,
	"actionButton": `P363hT`,
	"animatedButton": `M3c7qG`,
	"button-label": `ZOXb4j`,
	"buttonLabel": `ZOXb4j`,
	"buy-rent-button": `TSxjmb`,
	"buyRentButton": `TSxjmb`,
	"with-label": `BSyWNf`,
	"withLabel": `BSyWNf`,
	"video-info-button": `Vd_crt`,
	"videoInfoButton": `Vd_crt`,
	"all-cards-button": `_PBp_b`,
	"allCardsButton": `_PBp_b`,
	"info-overlay-wrapper": `B_wG0T`,
	"infoOverlayWrapper": `B_wG0T`,
	"active": `FhMWcS`,
	"info-overlay-content": `TEk3Sb`,
	"infoOverlayContent": `TEk3Sb`,
	"all-cards-overlay-content": `aRfedH`,
	"allCardsOverlayContent": `aRfedH`
};
export default ___CSS_LOADER_EXPORT___;
